module.exports = __webpack_public_path__ + "img/Orange.e0d4a4c3.jpg";